import type {
  AllowedFrameStyle,
  HighnoteEnvironment,
  PaymentCardFields,
} from "@highnoteplatform/types";

import { iframeUri } from "./config";

type BuildFrameConfig =
  | {
      uuid: string;
      field: PaymentCardFields;
      environment: HighnoteEnvironment;
      styles?: AllowedFrameStyle;
      enableClipboard?: boolean;
    }
  | {
      // Root (cardNumber) frame. Credentials are intentionally absent: they
      // are delivered over a MessagePort after load — never via the URL.
      uuid: string;
      environment: HighnoteEnvironment;
      styles?: AllowedFrameStyle;
      enableClipboard?: boolean;
      maskedOnLoad: boolean;
    };

export const buildFrame = (
  config: Readonly<BuildFrameConfig>
): HTMLIFrameElement => {
  const frame = document.createElement("iframe");

  const frameSource = new URL(
    "maskedOnLoad" in config
      ? `${iframeUri(config.environment)}?field=cardNumber&environment=${
          config.environment
        }&styles=${encodeURIComponent(
          JSON.stringify(config.styles ?? {})
        )}&enableClipboard=${
          config.enableClipboard ? "true" : "false"
        }&maskedOnLoad=${config.maskedOnLoad ? "true" : "false"}`
      : `${iframeUri(config.environment)}?field=${
          config.field
        }&styles=${encodeURIComponent(
          JSON.stringify(config.styles ?? {})
        )}&enableClipboard=${config.enableClipboard ? "true" : "false"}`
  );

  frameSource.hash = config.uuid;

  frame.setAttribute("src", frameSource.toString());
  frame.setAttribute("allow", "clipboard-write");
  frame.style.setProperty("border", "none");

  return frame;
};
